export interface UiStateModel {
  sideBarOpen: boolean;
  infoOnScreenOpen: boolean;
  appInfoOpen: boolean;
  startcodesMasked: boolean;
  forbidden403Access: boolean;
}

export const UiInitialState = {
  sideBarOpen: false,
  infoOnScreenOpen: false,
  appInfoOpen: false,
  startcodesMasked: true,
  forbidden403Access: false,
};

export interface UiStateActionToasterModel {
  message: string;
  summary: string;
  sticky?: boolean;
  testKey?: string;
}

export interface UiStateConfirmDialogModel {
  header: string;
  message: string;
  acceptLabel: string;
  rejectLabel: string;
}
